import { render, staticRenderFns } from "./screenTemplates.vue?vue&type=template&id=59714c15&scoped=true"
import script from "./screenTemplates.vue?vue&type=script&lang=js"
export * from "./screenTemplates.vue?vue&type=script&lang=js"
import style0 from "./screenTemplates.vue?vue&type=style&index=0&id=59714c15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59714c15",
  null
  
)

export default component.exports